/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  totalNewAccountsPerDayListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGet,
} from "../../funcs/totalNewAccountsPerDayListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGetRequest$inboundSchema,
};

export const tool$totalNewAccountsPerDayListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGet:
  ToolDefinition<typeof args> = {
    name:
      "new-accounts-per-day-v1",
    description: `List Total New Accounts Got Created Per Day

Original tool name: list-total-new-accounts-per-day-canister-id-get`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await totalNewAccountsPerDayListTotalNewAccountsPerDayApiV1LedgersLedgerCanisterIdTotalNewAccountsPerDayGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };